import { useCallback, useEffect, useState } from "react";
import Modal from "components/modal/Modal";
import "./re-design-modal.scss";
import x_mark from "assets/images/naf-redesign-close.svg";
import { getCurrentUserId, getIsReDesignAnnounced, setIsReDesignAnnounced } from "features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import { useSetRedesignAnnouncementMutation } from "pages/authentication/userService";

export default function RedesignAnnouncementModal() {
  const dispatch = useDispatch();
  const userId = useSelector(getCurrentUserId);
  const isReDesignAnnounced = useSelector(getIsReDesignAnnounced);
  const [modalOpen, setModalOpen] = useState(false);
  const { data: featureFlag } = useGetFeatureFlagsQuery();
  const [setRedesignAnnouncement] = useSetRedesignAnnouncementMutation();

  useEffect(() => {
    if (featureFlag?.redesignAnnouncementEnabled && !isReDesignAnnounced) {
      setModalOpen(true);
    }
  }, [featureFlag, isReDesignAnnounced]);

  const handleAnnouncementClose = useCallback(async () => {
    setModalOpen(false);
    if (userId) {
      dispatch(setIsReDesignAnnounced(true));
      await setRedesignAnnouncement({ userId });
    }
  }, [dispatch, setRedesignAnnouncement, userId]);
  if (!modalOpen) return null;
  return (
    <div className="announcement-modal">
      <Modal
        className="_announcement-modal"
        customHeader={<div className="announcement-modal__header">
          <h2 id="announcement-modal-title">Welcome to the New NAF Hub!</h2>
          <button
            type="button"
            className="announcement-modal__close"
            onClick={handleAnnouncementClose}
            aria-label="Close modal"
          >
            <img src={x_mark} alt="" aria-hidden="true" />
          </button>
        </div>
        }

        customBody={
          <div className="announcement-modal__body">
            <div className="announcement-modal__body__illustration" >
              <div className="announcement-modal__body__illustration__image"></div>
            </div>
            <div className="announcement-modal__body__description">
              We've upgraded your loan application management experience. The redesigned layout helps you and your Loan Officer complete tasks more efficiently to finalize your loan faster.
            </div>
            <div className="announcement-modal__body__summary-text">
              We’re excited to hear what you think!
            </div>
            <div className="announcement-modal__actions">
              <button className="announcement-modal__actions__continue" onClick={handleAnnouncementClose}>
                Continue
              </button>
            </div>
          </div>
        }

      />
    </div>
  );
}
